<template>
  <div class="hostess-rank-base" :class="{ kiko: packageName === 'kiko' }">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" :title="$t('lang.commonM.k240')" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
        </template>
        <template #right>
          <span class="tit-right" @click="handleToRule">
            <img class="left-nav" src="./images/h-q.png" alt="" />
          </span>
        </template>
      </van-nav-bar>
    </div>

    <div class="hostess-rank-bar" :style="{ 'margin-top': `-${barHeight + 46}px` }">
      <img v-if="packageName !== 'kiko'" class="base-bg" src="./images/h-head.png" />
      <img v-if="packageName === 'kiko'" class="base-bg" src="./images/h-head-kiko.png" />

      <div class="rank-head">
        <!-- Split 200,000 -->
        <div class="rank-reward">
          <img class="reward-cup" src="./images/h-winicon.png" />
          <MyPLabel :str="$t('lang.commonM.k166')" :numsOption="[{ value: thousandthDigit(totalReward) }]" />
          <img class="reward-bean" :src="getMatchImg('beans')" />
        </div>
        <!-- every Monday at 18:00 -->
        <!-- <div class="rank-time">{{ $t('lang.commonM.k167') }}</div> -->
        <MyPLabel class="rank-time" :str="$t('lang.commonM.k167')" :numsOption="[{ value: limitTime }]" />
      </div>

      <div class="prize">
        <div class="two">
          <div class="rank_c2_avatar">
            <img v-if="prize2.avatar" :src="prize2.avatar | imgPath" alt="" />
          </div>
          <div class="rank-sort">
            <img src="./images/h-second.png" />
          </div>
          <div class="item-num">
            <span class="name">{{ prize2.nickname }}</span>
            <span class="num">{{ prize2.score }}</span>
          </div>
        </div>

        <div class="one">
          <div class="rank_c1_avatar">
            <img v-if="prize1.avatar" :src="prize1.avatar | imgPath" alt="" />
          </div>
          <div class="rank-sort">
            <img src="./images/h-first.png" />
          </div>
          <div class="item-num">
            <span class="name">{{ prize1.nickname }}</span>
            <span class="num">{{ prize1.score }}</span>
          </div>
        </div>

        <div class="three">
          <div class="rank_c3_avatar">
            <img v-if="prize3.avatar" :src="prize3.avatar | imgPath" alt="" />
          </div>
          <div class="rank-sort">
            <img src="./images/h-third.png" />
          </div>
          <div class="item-num kiss-num3">
            <span class="name">{{ prize3.nickname }}</span>
            <span class="num">{{ prize3.score }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="hostess-rank-con">
      <div class="rank-body">
        <div class="date-limit">
          <div class="date-select">
            <div class="btn" @click="handleSelecWeek">
              {{ chooseWeek }}
              <img src="@/assets/packageAssets/common/arrow03.png" alt="" />
            </div>
            <div class="select" v-if="showWeek">
              <div @click="selectWeek(0, week0)">{{ this.week0 }}</div>
              <div @click="selectWeek(-1, week1)">{{ this.week1 }}</div>
            </div>
          </div>
          <span class="time">{{ $t('lang.commonM.k168') }}</span>
        </div>
        <template v-if="rankList && rankList.length > 0">
          <div class="agent-item" v-for="item in rankList" :key="item">
            <span class="rank-num" v-if="item.rank">{{ item.rank }}</span>
            <div class="avatar rank-avatar">
              <img v-if="item.avatar" :src="item.avatar | imgPath" alt="" />
              <span>{{ item.nickname }}</span>
            </div>
            <div class="item-num">
              {{ item.score }}
            </div>
          </div>
        </template>
        <div class="rank-nodata" v-else>
          {{ $t('lang.commonM.k169') }}
        </div>
      </div>

      <div class="agent-item owner-item" :style="{ 'margin-bottom': `${bottomBarHeight}px` }">
        <div class="owner-item-content">
          <div class="avatar">
            <span v-if="owners.rank && owners.rank > 0" class="rank-num">{{ owners.rank }}</span>
            <span v-else class="rank-num">--</span>
            <div class="avatar-box">
              <img v-if="owners.avatar" :src="owners.avatar | imgPath" alt="" />
              <div>
                <span class="owner-nickname">{{ owners.nickname }}</span>
                <span v-if="!owners.rank || !(owners.rank > 0)" class="owner-rank">{{ $t('lang.commonM.k169') }}</span>
              </div>
            </div>
          </div>
          <div class="item-num">
            {{ owners.score || 0 }}
          </div>
        </div>
      </div>
    </div>

    <div v-if="rankDiaShow" class="rank-mask">
      <div class="rank-dia">
        <div class="rank-dia-avatar">
          <img v-if="owners.avatar" :src="owners.avatar | imgPath" alt="" />
        </div>
        <div class="rank-dia-tit">{{ $t('lang.commonM.k170') }}</div>
        <MyPLabel
          v-if="configData.userRankRewardDTO.reward"
          class="rank-dia-tips"
          :numsOption="[{ value: `${configData.userRankRewardDTO.reward}`, style: packageName !== 'kiko' ? 'color:#a338fc' : 'color:#b79b21' }]"
          :str="$t('lang.commonM.k171')"
        />
        <div class="rank-dia-tips" v-else>{{ $t('lang.commonM.k171_1') }}</div>
        <div class="rank-dia-con">
          <div>
            <span>{{ $t('lang.commonM.k168') }}</span>
            <span>{{ configData.userRankRewardDTO.calls }}</span>
          </div>
          <div>
            <span>{{ $t('lang.kissGf.ranking') }}</span>
            <span v-if="configData.userRankRewardDTO.rank > 0">{{ configData.userRankRewardDTO.rank }}</span>
            <span v-else>{{ $t('lang.commonM.k169') }}</span>
          </div>
        </div>
        <!-- <div class="rank-dia-txt">{{ $t('lang.commonM.k173') }}</div> -->
        <MyPLabel class="rank-dia-txt" :str="$t('lang.commonM.k173')" :numsOption="[{ value: limitTime }]" />
        <template v-if="configData.userRankRewardDTO.reward">
          <div v-if="configData.userRankRewardDTO.rewardState == 1" class="rank-dia-btn" @click="handleSure('claim')">{{ $t('lang.commonM.k073') }}</div>
        </template>
        <div v-else class="rank-dia-btn" @click="handleSure('ok')">{{ $t('lang.ok') }}</div>

        <div :style="{ height: `${bottomBarHeight ? bottomBarHeight + 25 : 25}px` }"></div>
      </div>
    </div>

    <div v-if="rankRulesDiaShow" class="rank-mask">
      <div class="rank-dia rules-dia">
        <div class="rank-dia-tit">{{ $t('lang.commonM.k170') }}</div>
        <div class="rank-dia-tips">{{ $t('lang.commonM.k258') }}</div>
        <div class="rank-dia-con">
          <div class="list-fields right-read">
            <div class="field field1">{{ $t('lang.kissGf.ranking') }}</div>
            <div class="field field2">
              {{ $t('lang.mybean.bonus') }}
              <img :src="getMatchImg('beans')" />
            </div>
          </div>
          <div style="width: 100%; height: 1px; background-color: rgba(255, 255, 255, 0.2)"></div>
          <div class="list-fields right-read" v-for="(item, index) in configData.rankRewardDTOs" :key="index">
            <div v-if="index === 0" class="bd-field field1">
              <img src="./images/lv1.png" />
            </div>
            <div v-else-if="index === 1" class="bd-field field1">
              <img src="./images/lv2.png" />
            </div>
            <div v-else-if="index === 2" class="bd-field field1">
              <img src="./images/lv3.png" />
            </div>
            <div v-else class="bd-field field1">{{ item.range }}</div>
            <div class="bd-field field2">{{ item.rewardCount }}</div>
          </div>
        </div>

        <div class="rank-dia-btn" @click="handleToRule(true)">{{ $t('lang.instantPayment.dialogButtonText1') }}</div>

        <div :style="{ height: `${bottomBarHeight ? bottomBarHeight + 25 : 25}px` }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import { apiGetHostessRankApi, apiGetHostessRankCfgApi, apiGetHostessRankGetApi } from '@/api/imee.js'

export default {
  data() {
    return {
      bottomBarHeight: 0,
      rulesTipsShow: true,
      rankList: [],
      owners: {},
      showRules: false,
      prize1: { nickname: '', avatar: '', score: '', rank: '' },
      prize2: { nickname: '', avatar: '', score: '', rank: '' },
      prize3: { nickname: '', avatar: '', score: '', rank: '' },
      // 周选择
      showWeek: false,
      chooseWeek: '',
      week0: '',
      week1: '',
      week2: '',
      // dialog
      configData: null,
      rankDiaShow: false,
      totalReward: 0,
      limitTime: '',
      // 排行奖励规则
      rankRulesDiaShow: false
    }
  },
  methods: {
    isInThisWeek(date) {
      if (!date) return false

      const target = moment(date * 1)

      // 获取本周范围（周一作为起始）
      const startOfWeek = moment().startOf('isoWeek')
      const endOfWeek = moment().endOf('isoWeek')

      // 判断是否在本周范围内（包含边界值）
      return target.isBetween(startOfWeek, endOfWeek, null, '[]')
    },
    // 获取指定周的日期范围
    getWeekRange(weeksAgo = 0) {
      const beg = moment().subtract(weeksAgo, 'weeks').startOf('week').add(1, 'day').format('DD/MM')
      const end = moment().subtract(weeksAgo, 'weeks').endOf('week').add(1, 'day').format('DD/MM')

      return `${beg}-${end}`
    },
    // 选择天时间
    handleSelecWeek() {
      this.showWeek = !this.showWeek
    },
    selectWeek(type, week) {
      this.chooseWeek = week
      this.showWeek = false

      this.fatchRanking(type)
      // this.mockRanking()
    },
    // 规则
    handleToRule(cacheClicked) {
      if (cacheClicked) {
        const uid = this.getUid()
        window.localStorage.setItem(`rankingRulesDiaClicked${uid}`, 'clicked')
      }
      this.$router.push({ path: '/hostess-rank-rules' })
    },
    getConfig(trigger) {
      apiGetHostessRankCfgApi().then((resData) => {
        this.configData = resData || null
        // this.configData.userRankRewardDTO.reward = 100
        // this.configData.userRankRewardDTO.lastOpenRank = true
        // this.configData.userRankRewardDTO.rewardState = 1
        if (this.configData) {
          // 排行弹框提示
          if (this.configData.userRankRewardDTO) {
            const uid = this.getUid()
            let cacheTime = window.localStorage.getItem(`rankingBonusClickTime${uid}`)
            // 本周点过
            if (cacheTime && this.isInThisWeek(cacheTime)) {
              this.rankDiaShow = false
            }
            // 本周没点过
            else {
              if (
                this.configData.userRankRewardDTO.lastOpenRank === true &&
                (this.configData.userRankRewardDTO.rewardState == 1 || this.configData.userRankRewardDTO.rewardState == 0)
              ) {
                this.rankDiaShow = true
              }
            }
          }

          // 总奖励计算
          if (this.configData.rankRewardDTOs && this.configData.rankRewardDTOs.length) {
            // 总奖励 和 时间
            let count = 0
            this.configData.rankRewardDTOs.forEach((item) => {
              count += (item.rankEnd - item.rankStart + 1) * item.rewardCount
            })
            this.totalReward = count
            this.limitTime = resData.userRankRewardDTO.settleTime || '18:00'

            // 奖励规则
            this.configData.rankRewardDTOs.forEach((item) => {
              if (item.rankStart === item.rankEnd) {
                item.range = `${item.rankStart}`
                return
              }
              if (item.rankStart < item.rankEnd) {
                item.range = `${item.rankStart}-${item.rankEnd}`
              }
            })
          }

          // 奖励规则弹框提示 rankRulesDiaShow
          if (this.rankDiaShow === false && trigger != 'from_claim') {
            const uid = this.getUid()
            const rankingRulesDiaClicked = window.localStorage.getItem(`rankingRulesDiaClicked${uid}`)

            setTimeout(() => {
              this.rankRulesDiaShow = rankingRulesDiaClicked !== 'clicked'
            }, 1000)
          }
        }
      })
    },
    // 获取数据
    fatchRanking(arg) {
      apiGetHostessRankApi({ timeSpan: arg }).then((resData) => {
        if (resData) {
          // 排名数据
          if (resData.ranks && resData.ranks.length > 0) {
            // 前三名
            this.prize1 = resData.ranks[0] || { nickname: '', avatar: '', score: '', rank: '' }
            this.prize2 = resData.ranks[1] || { nickname: '', avatar: '', score: '', rank: '' }
            this.prize3 = resData.ranks[2] || { nickname: '', avatar: '', score: '', rank: '' }

            // 已排名
            if (this.prize1.rank) {
              this.rankList = resData.ranks && resData.ranks.slice(3)
            }
            // 未排名
            else {
              this.rankList = resData.ranks
            }
          }
          // 没数据
          else {
            this.prize1 = { nickname: '', avatar: '', score: '', rank: '' }
            this.prize2 = { nickname: '', avatar: '', score: '', rank: '' }
            this.prize3 = { nickname: '', avatar: '', score: '', rank: '' }
            this.rankList = []
          }

          // 用户数据
          if (resData.owners) {
            this.owners = resData.owners
          }
          // 没数据
          else {
            this.owners = {}
          }
        }
      })
    },
    // 模拟数据
    mockRanking() {
      const resData = {
        owners: {
          avatar: 'public/picture/2023-07-07/acf4942604ecae168398d19c38d92423.jpg',
          gifts: 0,
          nickname: 'Greenwalt',
          points: 0,
          presentId: '1079',
          uid: 1079,
          score: 123,
          rank: 4
        },
        ranks: [
          {
            avatar: 'public/app/picture/250322/17426128036575b21aa9a33da44c5R5828.jpg',
            gifts: 14,
            nickname: '453ysh',
            presentId: '7560252',
            uid: 4002,
            score: 4,
            rank: 1
          },
          {
            avatar: 'public/app/picture/250322/17426128036575b21aa9a33da44c5R5828.jpg',
            gifts: 14,
            nickname: '453ysh',
            presentId: '7560252',
            uid: 4002,
            score: 3,
            rank: 2
          },
          {
            avatar: 'public/app/picture/250322/17426128036575b21aa9a33da44c5R5828.jpg',
            gifts: 14,
            nickname: '453ysh',
            presentId: '7560252',
            uid: 4002,
            score: 2,
            rank: 3
          },
          {
            avatar: 'public/app/picture/250322/17426128036575b21aa9a33da44c5R5828.jpg',
            gifts: 14,
            nickname: '453ysh',
            presentId: '7560252',
            uid: 4002,
            score: 123,
            rank: 4
          }
        ]
      }
      if (resData) {
        // 排名数据
        if (resData.ranks && resData.ranks.length > 0) {
          resData.ranks = resData.ranks.concat(resData.ranks[1]).concat(resData.ranks[1])
          // 前三名
          this.prize1 = resData.ranks[0] || { nickname: '', avatar: '', score: '', rank: '' }
          this.prize2 = resData.ranks[1] || { nickname: '', avatar: '', score: '', rank: '' }
          this.prize3 = resData.ranks[2] || { nickname: '', avatar: '', score: '', rank: '' }
          // 已排名
          if (this.prize1.rank) {
            this.rankList = resData.ranks && resData.ranks.slice(3)
          }
          // 未排名
          else {
            this.rankList = resData.ranks
          }
        }
        // 没数据
        else {
          this.prize1 = { nickname: '', avatar: '', score: '', rank: '' }
          this.prize2 = { nickname: '', avatar: '', score: '', rank: '' }
          this.prize3 = { nickname: '', avatar: '', score: '', rank: '' }
          this.rankList = []
        }
        // 用户数据
        if (resData.owners) {
          this.owners = resData.owners
        }
        // 没数据
        else {
          this.owners = {}
        }
      }
    },
    handleSure(type) {
      if (type === 'claim') {
        apiGetHostessRankGetApi()
          .then((resData) => {
            if (resData) {
              this.$client.showToast(this.$t('lang.commonM.k074'))
              this.getConfig('from_claim')
            }
          })
          .finally(() => {
            this.rankDiaShow = false
          })
        return
      }
      if (type === 'ok') {
        let uid = this.getUid()
        window.localStorage.setItem(`rankingBonusClickTime${uid}`, Date.now())
        this.rankDiaShow = false
      }
    }
  },
  created() {
    // 本周
    this.week0 = this.getWeekRange(0)
    // 上周
    this.week1 = this.getWeekRange(1)
    // 上上周
    this.week2 = this.getWeekRange(2)

    // -2上上周 -1上周 0本周
    this.selectWeek(0, this.week0)

    this.getConfig()
  },
  mounted() {
    document.body.scrollTo({ top: 0 })

    // let uid = this.getUid()
    // let cacheRulesTipsShow = window.localStorage.getItem(`cacheRulesTipsShow${uid}`)
    // if (cacheRulesTipsShow === 'showed') {
    //   this.rulesTipsShow = false
    // }
  }
}
</script>

<style lang="less">
.hostess-rank-base {
  width: 100%;
  min-height: calc(100vh - 150px);
  .custom-nav-block {
    .van-bar {
      .van-nav-bar__content {
        .van-nav-bar__title {
          color: #ffffff;
          font-size: 17px;
          font-family: Outfit;
          font-weight: 600;
        }
        .van-nav-bar__right {
          .tit-right {
            line-height: 16px !important;
          }
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
img:not([src]) {
  opacity: 0;
}

.hostess-rank-base {
  width: 100%;
  min-height: calc(100vh - 150px);

  .custom-nav-block {
    background: url(./images/h-head.png) left top / 100% auto no-repeat;
    .van-bar {
      .van-nav-bar__content {
        .van-nav-bar__title {
          background-color: #ffffff;
        }
      }
    }
  }

  .hostess-rank-bar {
    padding-top: 108px;
    position: relative;
    .base-bg {
      width: 375px;
      height: 410px;
      position: absolute;
      top: 0;
      left: 0;
    }
    .rank-head {
      width: 272px;
      height: 64px;
      margin: 0 auto;
      position: relative;
      background: linear-gradient(90deg, rgba(117, 75, 246, 0) 0%, #7c53ff 54.44%, rgba(117, 75, 246, 0) 100%);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .rank-reward {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;

        color: #f9b428;
        text-align: center;
        font-family: Lora;
        font-size: 16px;
        font-style: italic;
        font-weight: 700;
        line-height: 24px;

        .reward-cup {
          width: 32px;
          height: 32px;
        }

        .reward-bean {
          width: 17px;
          height: 17px;
        }
      }
      .rank-time {
        color: #e4eaf8;
        text-align: center;
        font-family: Outfit Regular;
        font-size: 14px;
        line-height: 22px;
      }
    }
    .prize {
      width: 100%;
      margin: 10px auto;
      display: flex;
      .one,
      .two,
      .three {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        .item-num {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          .name {
            color: #ffffff;
            font-family: Outfit Regular;
            font-size: 16px;
            font-weight: 500;
            line-height: 24px;
            min-height: 24px;
          }
          .num {
            color: #fdca0f;
            font-family: Outfit Regular;
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
            min-height: 24px;
          }
        }
      }
      .two,
      .three {
        padding-top: 26px;
      }
      .one {
        .rank_c1_avatar {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          border: 3px solid #ffd00b;
          position: relative;
          img {
            object-fit: cover;
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
        .rank-sort {
          width: 40px;
          height: 40px;
          margin-top: -22px;
          position: relative;
          img {
            width: 40px;
            height: 40px;
          }
        }
      }
      .two {
        .rank_c2_avatar {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          border: 3px solid #dbdddf;
          position: relative;
          img {
            object-fit: cover;
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
        .rank-sort {
          width: 40px;
          height: 40px;
          margin-top: -22px;
          position: relative;
          img {
            width: 40px;
            height: 40px;
          }
        }
      }
      .three {
        .rank_c3_avatar {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          border: 3px solid #f59d4d;
          position: relative;
          img {
            object-fit: cover;
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
        .rank-sort {
          width: 40px;
          height: 40px;
          margin-top: -22px;
          position: relative;
          img {
            width: 40px;
            height: 40px;
          }
        }
      }
    }
  }

  .hostess-rank-con {
    width: 100%;
    min-height: 100vh;
    border-radius: 16px 16px 0 0;
    background: #ffffff;
    position: relative;

    .rank-body {
      padding: 16px;
      padding-bottom: 90px;
      border-radius: 0px 0px 16px 16px;
      position: relative;
      font-weight: normal;
      .date-limit {
        font-family: Outfit Regular;
        font-size: 14px;
        line-height: 18px;
        color: #222222;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
        .date-select {
          font-size: 14px;
          overflow: visible;
          .btn {
            position: relative;
            display: inline-flex;
            padding: 3px 10px;
            align-items: center;
            gap: 4px;
            border-radius: 20px;
            background: #e8e1ff;
            > img {
              width: 12px;
              height: 12px;
            }
          }
          .select {
            position: absolute;
            z-index: 100;
            width: 107px;
            margin-top: 8px;
            background: #ffffff;
            color: #666666;
            font-size: 14px;
            box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
            > div {
              height: 30px;
              margin: 5px 0;
              line-height: 30px;
              text-align: center;
            }
          }
        }
        .time {
          float: right;
          color: #999999;
          font-family: Outfit Regular;
          font-size: 14px;
        }
      }
      .rank-nodata {
        width: 100%;
        text-align: center;
        padding-top: 90px;
        font-size: 14px;
        color: #999;
        font-family: Outfit Medium;
      }
    }
    .agent-item {
      height: 40px;
      margin-bottom: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-family: Inter;
      &:last-child {
        margin-bottom: 0;
      }
      .rank-num {
        display: block;
        min-width: 18px;
        margin-right: 10px;
        font-family: Outfit Medium;
        font-size: 18px;
        color: #333333;
      }
      .avatar {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-family: Outfit Medium;
        color: #222222;
        > img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 10px;
          object-fit: cover;
        }
      }
      .rank-avatar {
        flex: 1 !important;
      }
      .item-num {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-family: Outfit Medium;
        color: #a338fc;
        > img {
          width: 28px;
          height: 25px;
          margin-left: 10px;
        }
        i {
          padding-left: 6px;
          font-size: 14px;
          color: #666666;
          font-weight: 400;
        }
      }
    }
    .owner-item {
      width: 375px;
      height: 69px;
      position: fixed;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      border-radius: 16px 16px 0 0;
      background: #e8e1ff;
      .owner-item-content {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        padding: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .avatar {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          .rank-num {
            font-size: 18px;
            font-weight: 500;
            color: #aeaeb2;
          }
          .not-in-rank {
            display: inline-block;
            width: 31px;
            height: 24px;
            position: relative;
            &::before {
              content: '';
              width: 8px;
              height: 2px;
              background: #aeaeb2;
              position: absolute;
              left: 50%;
              top: 50%;
              margin-left: -9px;
              margin-top: -1px;
            }
            &::after {
              content: '';
              width: 8px;
              height: 2px;
              background: #aeaeb2;
              position: absolute;
              left: 50%;
              top: 50%;
              margin-left: 1px;
              margin-top: -1px;
            }
          }
          .avatar-box {
            display: flex;
            align-items: center;
            > img {
              width: 36px;
              height: 36px;
              border-radius: 50%;
              object-fit: cover;
            }
            > div {
              display: flex;
              flex-direction: column;
              justify-content: center;
              padding-left: 12px;
              max-width: 180px;
              overflow: hidden;
              .owner-nickname {
                color: #222222;
                font-family: Outfit Medium;
                font-size: 18px;
                font-weight: 500;
                line-height: 20px;
              }
              .owner-rank {
                color: #999999;
                font-family: Outfit Medium;
                font-size: 12px;
                font-weight: 400;
                line-height: 14px;
              }
            }
          }
        }
        .item-num {
          color: #a338fc;
          i {
            color: #a338fc;
          }
        }
      }
    }
  }

  .rank-mask {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    .rank-dia {
      width: 375px;
      min-height: 388px;
      padding: 50px 16px 0;
      border-radius: 20px 20px 0 0;
      background-color: #ffffff;
      position: relative;
      .rank-dia-avatar {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        position: absolute;
        top: -50px;
        left: 50%;
        margin-left: -50px;
        overflow: hidden;
        img {
          width: 100%;
          object-fit: cover;
        }
      }
      .rank-dia-tit {
        color: #222222;
        text-align: center;
        font-family: Outfit Regular;
        font-size: 18px;
        font-weight: 500;
        line-height: 28px;
        margin-top: 12px;
      }
      .rank-dia-tips {
        width: 320px;
        margin: 0 auto;
        color: #000000;
        text-align: center;
        font-family: Outfit Regular;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        margin-top: 8px;
        img {
          width: 20px;
          display: inline-block;
          vertical-align: middle;
        }
      }
      .rank-dia-con {
        width: 327px;
        min-height: 84px;
        margin: 16px auto;
        border-radius: 4px;
        background: #f4f5f7;
        padding: 5px 10px 12px;
        & > div {
          height: 42px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            &:first-child {
              color: #999999;
              text-align: center;
              font-family: Outfit Regular;
              font-size: 16px;
              font-weight: 400;
              line-height: 24px;
            }
            &:last-child {
              color: #a338fc;
              text-align: center;
              font-family: Outfit Regular;
              font-size: 16px;
              font-weight: 500;
              line-height: 24px;
            }
          }
        }
      }
      .rank-dia-txt {
        color: #999999;
        text-align: center;
        font-family: Outfit Regular;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        margin-top: 12px;
      }
      .rank-dia-btn {
        width: 327px;
        margin: 16px auto;
        padding: 10px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-family: Outfit Regular;
        font-size: 18px;
        font-weight: 500;
        line-height: 28px;
        border-radius: 24px;
        background: #a338fc;
      }
    }
    .rules-dia {
      background: url(./images/d-rulebg.png) center center / 100% 100% no-repeat;
      padding-top: 24px;
      .rank-dia-tit {
        color: #fff;
        text-align: center;
        font-family: Outfit;
        font-size: 18px;
        font-weight: 600;
        line-height: 28px;
        margin-top: 0;
      }
      .rank-dia-tips {
        color: #ffffff;
        text-align: center;
        font-family: Outfit Regular;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
      }
      .rank-dia-con {
        padding: 5px 0 12px;
        border-radius: 16px;
        background: rgba(118, 66, 255, 0.8);

        .list-fields {
          width: 100%;
          display: flex;
          margin: 6px 0;
          padding: 0 25px;
          justify-content: space-between;
          .field {
            font-family: RobotoFlex;
            font-weight: 400;
            font-size: 18px;
            color: #ffffff;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 17px;
              height: 17px;
              margin: 0 2px;
            }
          }
          .field1 {
            width: 30%;
            text-align: center;
          }
          .field2 {
            width: 30%;
            text-align: center;
          }

          .bd-field {
            min-height: 36px;
            font-family: RobotoFlex;
            font-weight: 400;
            font-size: 15px;
            color: #ffffff;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 36px;
              height: 36px;
            }
          }
          .bd-field.field1 {
            font-family: Outfit;
            font-size: 18px;
            font-weight: 700;
          }
          .bd-field.field2 {
            color: #fdca0f;
            font-family: Outfit;
            font-size: 18px;
            font-weight: 700;
          }
        }
      }
      .rank-dia-btn {
        background: linear-gradient(90deg, #8828ff 0%, #8561ff 100%);
      }
    }
  }
}
</style>

<style lang="less" scoped>
@import './styles/index.less';
</style>
